import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useGlobalStore } from './contexts';
import { getAuthrtMenu } from '../services/UtilService';
import { doLogout } from '../apis/loginApi';

const HeaderNew = () => {
  const { store, updateStore, remainingTime, resetTimer } = useGlobalStore();
  const [headerMenu, setHeaderMenu] = useState([]);
  const [logoClass, setLogoClass] = useState('logo');
  const location = useLocation();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(null);
  const isMainPage = location.pathname === '/';

  const [mbMenu, setMbMenu] = useState([]);
  const [openMbMenu, setOpenMbMenu] = useState(false);

  useEffect(() => {
    if (openMbMenu) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [openMbMenu]);

  const formatTime = milliseconds => {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.floor((milliseconds % 3600000) / 60000);
    const seconds = ((milliseconds % 60000) / 1000).toFixed(0);

    const restr = `${
      hours > 0 ? hours + '시간' : ''
    } ${minutes}분 ${seconds}초`;

    return restr;
  };

  const getMenu = async () => {
    let menuList = [];

    try {
      menuList = await getAuthrtMenu(store.authrtId);
      updateStore('menuList', menuList);
      setHeaderMenu(menuList.filter(menu => menu.level === 0));
    } catch (error) {}
  };

  useEffect(() => {
    if (store?.menuList?.length >= 0) {
      const menuList = store.menuList;
      setHeaderMenu(menuList.filter(menu => menu.level === 0));
      setMbMenu(menuList);
    }
  }, [store.menuList]);

  useEffect(() => {
    if (store.authrtId === 'ADMIN') {
      setLogoClass('logo admin');
    } else {
      setLogoClass('logo');
    }
  }, [store.authrtId]);

  useEffect(() => {
    if (store.authrtId === 'NU') {
      getMenu();
    }
  }, []);

  const fnDownloadManual = () => {
    const manualFileName =
      store.authrtId === 'ADMIN'
        ? 'SW-DV-007-관리자매뉴얼_V1.0.pdf'
        : 'SW-DV-007-사용자매뉴얼_V1.4.pdf';

    const url = `/manual/${manualFileName}`;
    const a = document.createElement('a');
    a.href = url;
    a.style.display = 'none';
    a.rel = 'noopener noreferrer';
    a.download = manualFileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const fnLogout = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (token) {
        await doLogout(token); // 로그아웃 API 호출
      }
    } catch (e) {}

    sessionStorage.removeItem('token');

    updateStore('authrtId', 'NU');
    updateStore('menuList', []);
    updateStore('logined', false);
    updateStore('userType', '');
    updateStore('entSn', '');
    updateStore('userSn', '');
    updateStore('userId', '');
    updateStore('userNm', '');
    updateStore('selectedFirstDepthMenu', '');

    let menuList = [];

    try {
      menuList = await getAuthrtMenu('NU');
      updateStore('menuList', menuList);
      setHeaderMenu(menuList.filter(menu => menu.level === 0));
    } catch (error) {}

    sessionStorage.removeItem('remainingTime');
    sessionStorage.clear();

    navigate('/');
  };

  return (
    <>
      <header
        id="header"
        style={{
          zIndex: openMbMenu && 1000,
        }}
      >
        <div className="header-in">
          <div className="head-body">
            <div className="inner">
              <div className="head-in">
                <h1 className={logoClass}>
                  <Link to="/">
                    <img
                      src={require('../assets/img/layout/logo.svg').default}
                      className="logo-im"
                      alt="산업재해부담작업예방플랫폼"
                    />
                  </Link>
                </h1>
                <div className="right">
                  {store?.logined ? (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        <span>
                          <strong>{`${store?.userNm}님. 환영합니다.`}</strong>
                          &nbsp;&nbsp;
                        </span>
                        <span>
                          로그아웃까지 남은 시간:{' '}
                          <strong>{formatTime(remainingTime)}</strong>
                        </span>
                      </div>
                      <button
                        onClick={() => resetTimer(true)}
                        className="btn-navi navi-row"
                      >
                        연장하기
                      </button>
                      <button
                        className="btn-navi navi-row logout"
                        onClick={() => {
                          fnLogout();
                        }}
                      >
                        로그아웃
                      </button>

                      <button
                        className="btn-navi navi-row logout"
                        onClick={() => {
                          fnDownloadManual();
                        }}
                      >
                        메뉴얼 다운로드
                      </button>
                      <button
                        type="button"
                        className="btn-navi navi-row all"
                        aria-controls="mobile-nav"
                        aria-expanded={openMbMenu}
                        onClick={() => {
                          setOpenMbMenu(!openMbMenu);
                        }}
                      >
                        전체메뉴
                      </button>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/member/login"
                        className="btn-navi navi-row login"
                      >
                        로그인
                      </Link>
                      <Link
                        to="/member/joinPage"
                        className="btn-navi navi-row join"
                      >
                        회원가입
                      </Link>
                      <button
                        type="button"
                        className="btn-navi navi-row all"
                        aria-controls="mobile-nav"
                        aria-expanded={openMbMenu}
                        onClick={() => {
                          setOpenMbMenu(!openMbMenu);
                        }}
                      >
                        전체메뉴
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <nav className="krds-gnb">
            <div className="inner">
              <ul className="gnb-menu">
                {headerMenu.map((menu, index) => (
                  <li key={index}>
                    <button
                      type="button"
                      className="gnb-main-trigger"
                      onClick={() => {
                        updateStore('selectedFirstDepthMenu', menu.menuId);
                        navigate(menu.menuPath);
                      }}
                    >
                      {menu.menuNm}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
        <div
          id="mobile-nav"
          className={`krds-gnb-mobile ${
            openMbMenu ? 'is-backdrop is-open' : ''
          }`}
          aria-hidden={!openMbMenu}
        >
          <div className="gnb-wrap type-header-tab" tabIndex={0}>
            <div className="gnb-header">
              <div className="gnb-utils">
                <button
                  type="button"
                  className="krds-btn medium icon"
                  id="close-nav"
                  onClick={() => {
                    setOpenMbMenu(false);
                  }}
                >
                  <span className="sr-only">전체메뉴 닫기</span>
                  <i className="svg-icon ico-popup-close"></i>
                </button>
              </div>
              <div className="gnb-login">
                {store?.logined ? (
                  <>
                    <span className="user">test{`${store?.userNm}님`}</span>
                    <button
                      type="button"
                      className="krds-btn medium text"
                      onClick={() => {
                        setOpenMbMenu(false);
                        fnLogout();
                      }}
                    >
                      <i className="svg-icon ico-logout"></i> 로그아웃
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/member/login"
                      className="krds-btn medium text"
                      onClick={() => {
                        setOpenMbMenu(false);
                      }}
                    >
                      <i className="svg-icon ico-log"></i>로그인을 해주세요
                    </Link>
                  </>
                )}
              </div>
              <div className="gnb-body">
                <div className="gnb-menu">
                  <div className="submenu-wrap">
                    {mbMenu.length > 0 &&
                      mbMenu.map((menu, index) => (
                        <div
                          id={`mGnb-anchor${index + 1}`}
                          className="gnb-sub-list"
                          role="tabpanel"
                          aria-labelledby={`tab-${index}`}
                          key={menu.menuId}
                        >
                          <h3 className="sub-title">
                            <span>{menu.menuNm}</span>
                          </h3>
                          <ul>
                            {menu.children?.length > 0 &&
                              menu.children.map(subMenu1 => {
                                return (
                                  <>
                                    {subMenu1.children?.length > 0 ? (
                                      <>
                                        {subMenu1.children.map(subMenu2 => {
                                          return (
                                            <li key={subMenu2.menuId}>
                                              <Link
                                                to={subMenu2.menuPath}
                                                className="gnb-sub-trigger"
                                              >
                                                {subMenu2.menuNm}
                                              </Link>
                                            </li>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <li key={subMenu1.menuId}>
                                        <Link
                                          to={subMenu1.menuPath}
                                          className="gnb-sub-trigger"
                                          onClick={() => {
                                            setOpenMbMenu(false);
                                          }}
                                        >
                                          {subMenu1.menuNm}
                                        </Link>
                                      </li>
                                    )}
                                  </>
                                );
                              })}
                          </ul>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderNew;
